import { AllRolesRequested } from './../_actions/role.actions';
// Angular
import { Injectable, Inject, NgZone } from '@angular/core';
import { Router } from '@angular/router';
// RxJS
import { filter, mergeMap, tap, withLatestFrom, catchError, delay } from 'rxjs/operators';
import { defer, Observable, of } from 'rxjs';
// NGRX
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action, select, Store } from '@ngrx/store';
// Auth actions
import { AuthActionTypes, Login, Logout, Register, UserLoaded, UserRequested } from '../_actions/auth.actions';
import { AuthService } from '@core/auth';
import { AppState } from '../../reducers';
import { isUserLoaded } from '@core/auth';
import { HttpClient } from '@angular/common/http';
import moment from 'moment';
import { BrowserCookieStorage } from '@core/_services/browser-cookie.storage';

@Injectable()
export class AuthEffects {
  @Effect({ dispatch: false })
  login$ = this.actions$.pipe(
    ofType<Login>(AuthActionTypes.Login),
    tap((action) => {
      this.storage.removeItem('Authorization');
      this.storage.setItem('Authorization', action.payload.authToken, { expires: moment().add(1, 'days').toDate() });

      this.setQlikCookie(action.payload.authToken);
      this.store.dispatch(new AllRolesRequested());
      this.store.dispatch(new UserRequested());
    }),
  );

  @Effect({ dispatch: false })
  logout$ = this.actions$.pipe(
    ofType<Logout>(AuthActionTypes.Logout),
    tap(async (action) => {
      this.storage.removeItem('Authorization');

      if (action.payload.redirect) {
        this.router.navigate(['/', 'auth', 'login']);
      }
    }),
  );

  @Effect({ dispatch: false })
  register$ = this.actions$.pipe(
    ofType<Register>(AuthActionTypes.Register),
    tap((action) => {
      this.storage.setItem('Authorization', action.payload.authToken, { expires: moment().add(1, 'days').toDate() });

      this.setQlikCookie(action.payload.authToken);
    }),
  );

  @Effect({ dispatch: false })
  loadUser$ = this.actions$.pipe(
    ofType<UserRequested>(AuthActionTypes.UserRequested),
    withLatestFrom(this.store.pipe(select(isUserLoaded))),
    filter(([action, isLoaded]) => !isLoaded),
    mergeMap(() => this.auth.getUserByToken()),
    tap((user) => {
      if (user) {
        this.store.dispatch(new UserLoaded({ user }));
      } else {
        this.store.dispatch(new Logout({ redirect: true }));
      }
    }),
  );

  @Effect()
  init$: Observable<Action> = defer(() => {
    const userToken = this.storage.getItem('Authorization');
    let observableResult = of({ type: 'NO_ACTION' });

    if (userToken) {
      observableResult = of(new Login({ authToken: userToken }));
    }

    return observableResult;
  });

  constructor(
    private actions$: Actions,
    private router: Router,
    private auth: AuthService,
    private storage: BrowserCookieStorage,
    private http: HttpClient,
    private store: Store<AppState>,
  ) {}

  private async setQlikCookie(token: string): Promise<any> {
    return this.http
      .get('https://qlikcorp.vipservice.ru/jwt/single/?appid=323506c7-fe2f-4d91-a94c-ec8d5e496485', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        observe: 'response',
        responseType: 'text',
        withCredentials: true,
      })
      .pipe(
        tap(() => this.auth.hasQlik$.next(true)),
        catchError((err) => {
          console.log(err);
          return of(err);
        }),
      )
      .toPromise();
  }
}
